import { render, staticRenderFns } from "./SimpleNumberInput.vue?vue&type=template&id=71b47e3d&"
import script from "./SimpleNumberInput.vue?vue&type=script&lang=js&"
export * from "./SimpleNumberInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports